import VueGtm from 'vue-gtm'
import Vue from 'vue'
import router from './router'
import { getCookie, LoadFacebookPixel } from './utils'

// The consent dialog itself is served by /api/legal/privacy/script.js (see public/index.html).
// This module only reacts to the consent decision that script broadcasts on window.Kvass.
const consents = ['required', 'statistics', 'marketing']

function onConsentChange(res = []) {
  let dataLayer = window.dataLayer || []

  let blocked = consents.filter(c => !res.includes(c))

  dataLayer.push(...blocked.map(c => ({ event: `consent:block:${c}` })))

  //load facebook pixel if marketing consent
  if (!blocked.includes('marketing') && KvassConfig.facebookPixel)
    LoadFacebookPixel(KvassConfig.facebookPixel)

  let id = getCookie('kvass.gtm')
  if (!id) return

  Vue.use(VueGtm, {
    id,
    debug: Boolean(getCookie('gtm.debug')),
    vueRouter: router,
  })
}

if (window.Kvass) window.Kvass.on('consent:change', onConsentChange)
